import { styled } from 'styled-components';

export const Label = styled.label`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.neutral700};
  font-size: 18px;
  font-weight: 500;
  margin-bottom: ${({ theme }) => theme.sizes.xs};
`;
